export default (cart) => ({
	event: 'cart-edit-shipping-link', // @todo use camelCase event name
	orderId: cart.order.id,
	contentGroup: cart.order.contentGroup
});
